// google-login.js — #1401
//
// Lógica post-credencial del sign-in con Google, separada de
// GoogleSignInButton.js para que sea testeable: el botón de Google vive
// DENTRO de un iframe cross-origin que Playwright no puede apretar (design.md
// "Simulación de Google en los tests"). Acá queda la parte pura: qué destino
// le toca a la respuesta del backend y cómo se guarda la sesión.

import { establecerSesion } from "./session-token";

// #1525 R7 (reemplaza R20 de #1401): `created: true` (cuenta recién creada, con
// la prueba corta del backend ya concedida) va al onboarding en
// /perfil/verificacion, paso Bienvenida. Antes iba directo a /turno y la piel
// nueva con las preguntas de perfil casi nadie las veía. El Turno sigue
// habilitado desde el segundo cero: el onboarding es todo opcional y sale con
// "Saltar" / "Completar después". `created: false` (cuenta que ya existía) va a
// /authentication, que resuelve el destino real con `destinoSegunCuenta`
// (Authentication.js) — NO al `verification_status` crudo de la respuesta, que
// mandaba a /perfil/verificacion a toda cuenta no aprobada aunque ya tuviera
// acceso completo. Spec: .claude/specs/1525-onboarding-higgsfield/
export const destinoTrasGoogle = ({ created }) => (created ? "/perfil/verificacion" : "/authentication");

// Guarda el token y devuelve el destino. Lanza si algo no se pudo hacer (sin
// token, o el navegador no deja escribir la sesión) para que el caller decida
// cómo mostrar el error — no navega ni pinta nada acá.
export const completarLoginGoogle = (data) => {
  const { token, created } = data || {};
  if (!token) {
    throw new Error("Sin token en respuesta");
  }
  if (!establecerSesion(token)) {
    throw new Error("No pudimos guardar la sesión en este navegador");
  }
  return destinoTrasGoogle({ created });
};

// ── #1453 R7/R11 · la casilla de Términos y el POST a /api/user/google/ ─────
// El front no sabe, antes de llamar, si la cuenta de Google ya existe. Por eso:
// - Registro ("Crear cuenta", `requireTos`): sin la casilla marcada no se llama
//   al servidor (R7).
// - Login: se llama SIN casilla pidiendo `solo_cuenta_existente: true`. Una
//   cuenta existente entra; una nueva vuelve con 428 `requiere_terminos` y el
//   servidor NO la crea. Recién ahí el login muestra la casilla, y el reintento
//   (`crear`) vuelve a exigirla antes de llamar (R11 v2).

// ¿Hay que cortar ANTES del POST porque falta la casilla?
export const faltaCasillaGoogle = ({ requireTos = false, crear = false, tosAccepted = false }) =>
  (requireTos || crear) && !tosAccepted;

// Cuerpo del POST. `accept_tos` solo va como booleano y solo con la casilla
// marcada; sin casilla, el login pide que no se cree una cuenta nueva.
export const cuerpoPostGoogle = ({ idToken, tosAccepted = false, soloCuentaExistente = false }) => {
  const body = { id_token: idToken };
  if (tosAccepted) body.accept_tos = true;
  else if (soloCuentaExistente) body.solo_cuenta_existente = true;
  return body;
};

// El servidor respondió "esta cuenta es nueva y le faltan los Términos".
export const esRequiereTerminos = (err) =>
  err?.response?.status === 428 && err?.response?.data?.code === "requiere_terminos";
